'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 6h-2V4h2v4zm3 0h-2V4h2v4zm3 0h-2V4h2v4z' });

var SdCard = function SdCard(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

SdCard = (0, _pure2.default)(SdCard);
SdCard.muiName = 'SvgIcon';

exports.default = SdCard;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/SdCard.js
// module id = 2803
// module chunks = 0